var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9754 6.87109L5.07008 16.7861C5.02032 16.8358 4.95792 16.8716 4.88942 16.8887L0.48317 17.9873C0.452215 17.9951 0.420519 17.999 0.38942 17.999C0.287418 17.999 0.187254 17.959 0.114029 17.8857C0.0172319 17.7888 -0.0213469 17.6474 0.0114899 17.5146L1.10915 13.1035C1.12632 13.0358 1.16198 12.9728 1.21169 12.9229L11.116 3.00781L14.9754 6.87109ZM13.5701 0.552734C14.3061 -0.184127 15.5901 -0.184858 16.3269 0.552734L17.4295 1.65625C17.7974 2.02467 17.9998 2.51486 17.9998 3.03613C17.9998 3.55744 17.7975 4.04774 17.4295 4.41602L16.0789 5.76758L12.2195 1.9043L13.5701 0.552734Z",
    fill: "#001A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 1.375C5.8797 1.375 6.1875 1.6828 6.1875 2.0625V4.8125H8.9375C9.3172 4.8125 9.625 5.1203 9.625 5.5C9.625 5.8797 9.3172 6.1875 8.9375 6.1875H6.1875V8.9375C6.1875 9.3172 5.8797 9.625 5.5 9.625C5.1203 9.625 4.8125 9.3172 4.8125 8.9375V6.1875H2.0625C1.6828 6.1875 1.375 5.8797 1.375 5.5C1.375 5.1203 1.6828 4.8125 2.0625 4.8125H4.8125V2.0625C4.8125 1.6828 5.1203 1.375 5.5 1.375Z",
    fill: "#001A39",
    transform: "translate(11 11) scale(0.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilPlus);
export default __webpack_public_path__ + "static/media/PencilPlus.c64dd4cb696ad3e17cc64cd79701b547.svg";
export { ForwardRef as ReactComponent };